import React from "react";
import { Container, Button } from "@material-ui/core";
import axios from "axios";
import ScoreSlider from "hearing/assets/digits/score-slider";
import { P1, P2, P3 } from 'assets/fonts';

class Hearing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      hearing: {},
    };
  }

  componentDidMount = async () => {
    const doc = await axios.get("/api/hearing/digits/pre-test/questions");
    const questions = doc.data.map((data) => data.question);
    this.setState({ questions });
  };

  validateHearing = () => {
    const { questions, hearing } = this.state;
    if (Object.keys(hearing).length !== questions.length) return false;
    for (const key in hearing) {
      if (Object.keys(hearing[key]).length !== 2) return false;
    }
    return true;
  };

  handleWellness = (index, value) => {
    const { hearing, questions } = this.state;
    this.setState(() => {
      if (hearing[questions[index]]) {
        const obj = hearing[questions[index]];
        obj["wellness"] = value;
      } else {
        hearing[questions[index]] = {
          wellness: value,
        };
      }
      return { hearing };
    });
  };

  handleConfidence = (index, value) => {
    const { hearing, questions } = this.state;
    this.setState(() => {
      if (hearing[questions[index]]) {
        const obj = hearing[questions[index]];
        obj["confidence"] = value;
      } else {
        hearing[questions[index]] = {
          confidence: value,
        };
      }
      return { hearing };
    });
  };

  renderButton = () => {
    const { questions, hearing } = this.state;
    if (questions.length === 0) {
      return null;
    } else if (this.validateHearing()) {
      return (
        <Button
          variant="contained"
          size="large"
          onClick={() => this.props.handleClick(hearing)}
          style={{
            color: "white", backgroundColor: "#107896",
            width: 200,
            marginBottom: 10,
          }}
        >
          OK
        </Button>
      );
    } else {
      return (
        <Button
          variant="contained"
          size="large"
          style={{
            width: 200,
            marginBottom: 10,
            color: "white", backgroundColor: "#107896"
          }}
          disabled={true}
        >
          OK
        </Button>
      );
    }
  };

  render() {
    const { hearing, questions } = this.state;
    return (
      <Container>
        <div
          style={{
            position: "relative",
            marginTop: "5%",
            marginBottom: "5%",
            marginLeft: "10%",
            marginRight: "10%",
          }}
        >
          <br />
          {questions.map((question, index) => {
            return (
              <div style={{ marginTop: 10 }}>
                <P2>{question}</P2>
                <P2>How well you hear in this situation?</P2>
                {hearing[questions[index]] &&
                  hearing[questions[index]].wellness ? null : (
                  <P3 className="text-danger">* must provide value</P3>
                )}
                <div className="row">
                  <P3 style={{ marginTop: 10, marginLeft: 15 }}>
                    Not well at all
                  </P3>
                  <P3 style={{ marginTop: 10, marginLeft: "30%" }}>
                    Very well
                  </P3>
                </div>
                <ScoreSlider
                  handleScore={(value) => this.handleWellness(index, value)}
                  style={{ marginLeft: "30%" }}
                />
                <P2>
                  How confident are you that you can manage this situation?
                </P2>
                {hearing[questions[index]] &&
                  hearing[questions[index]].confidence ? null : (
                  <P3 className="text-danger">* must provide value</P3>
                )}
                <div className="row">
                  <P3 style={{ marginTop: 10, marginLeft: 15 }}>
                    Not confident
                  </P3>
                  <P3 style={{ marginTop: 10, marginLeft: "28%" }}>
                    Very confident
                  </P3>
                </div>
                <ScoreSlider
                  handleScore={(value) => this.handleConfidence(index, value)}
                  style={{ marginLeft: "30%" }}
                />
                <br />
              </div>
            );
          })}
          <br />
          {this.renderButton()}
        </div>
      </Container>
    );
  }
}

export default Hearing;
